import { useSelectBase } from './useSelectBase'; // ajuste o caminho conforme necessário

/**
 * Hook genérico para gerenciar selects com dados locais
 *
 * @param {object} params
 * @param {string} params.fieldId - Caminho do campo no formData (ex: 'groups')
 * @param {object} params.formData - Dados do formulário
 * @param {Function} params.setFormData - Setter do form
 * @param {Array} params.rawOptions - Dados crus (ex: [{id: 1, name: 'A'}])
 * @param {Function} params.mapToOption - Transforma item da lista para {value, label}
 * @param {boolean} [params.isMulti=false] - Select múltiplo?
 */
const useSelectOptions = ({
  fieldId,
  formData,
  setFormData,
  rawOptions = [],
  mapToOption,
  isMulti = false,
}) => {
  return useSelectBase({
    fieldId,
    formData,
    setFormData,
    rawOptions,
    mapToOption,
    isMulti,
  });
};

export default useSelectOptions;
